import { types as AuthTypes } from 'core/logic/authentication'

export const mapPlatformToLabel = {
  [AuthTypes.Platform.gmail]: 'Google',
  [AuthTypes.Platform.facebook]: 'Facebook',
  [AuthTypes.Platform.metamask]: 'Metamask',
}
